import { render, staticRenderFns } from "./TableNotesAvatarNew.vue?vue&type=template&id=0668a9f3&scoped=true"
import script from "./TableNotesAvatarNew.vue?vue&type=script&lang=ts"
export * from "./TableNotesAvatarNew.vue?vue&type=script&lang=ts"
import style0 from "./TableNotesAvatarNew.vue?vue&type=style&index=0&id=0668a9f3&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0668a9f3",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0668a9f3')) {
      api.createRecord('0668a9f3', component.options)
    } else {
      api.reload('0668a9f3', component.options)
    }
    module.hot.accept("./TableNotesAvatarNew.vue?vue&type=template&id=0668a9f3&scoped=true", function () {
      api.rerender('0668a9f3', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/table/TableNotesAvatarNew.vue"
export default component.exports